// MobileMenu.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import GlobalStyles from "@mui/material/GlobalStyles";

interface MobileMenuProps {
  routes: any[];
  tipoUsuario: number;
}

export default function MobileMenu({ routes, tipoUsuario }: MobileMenuProps) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openSubmenus, setOpenSubmenus] = useState<Record<string, boolean>>({});

  const toggleSubmenu = (key: string) => {
    setOpenSubmenus((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const navRoutes = routes.filter(
    (r: any) =>
      r.type === "collapse" && r.key !== "perfil" && (r?.allow || []).includes(tipoUsuario)
  );

  const perfilRoute = routes.find((r: any) => r.key === "perfil") as any;
  const perfilItems = ((perfilRoute?.collapse as any[]) || []).filter((c: any) =>
    (c?.allow || []).includes(tipoUsuario)
  );

  const renderItems = (items: any[], depth = 0): JSX.Element[] =>
    items
      .filter((c: any) => (c?.allow || []).includes(tipoUsuario))
      .map(
        (item: any, i: number): JSX.Element => (
          <li
            key={item.key}
            style={{
              animationDelay: `${(i + 1) * 60}ms`,
              //paddingLeft: depth > 0 ? "20px" : "0",
            }}
          >
            {item.collapse ? (
              <>
                <button onClick={() => toggleSubmenu(item.key)}>
                  {item.name}
                  <span className="mob-chevron">{openSubmenus[item.key] ? "▲" : "▼"}</span>
                </button>
                {openSubmenus[item.key] && (
                  <ul className="mob-submenu">{renderItems(item.collapse, depth + 1)}</ul>
                )}
              </>
            ) : (
              <button
                onClick={() => {
                  navigate(item.route);
                  setOpen(false);
                }}
              >
                {item.name}
              </button>
            )}
          </li>
        )
      );

  return (
    <>
      <GlobalStyles
        styles={`
        @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Malayalam:wght@100..900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
        .mob-burger-container {
            background-color: #041d45;
            border-radius: 100%;
            cursor: pointer;
            position: fixed;
            width: 210px;
            height: 210px;
            left: -120px;
            top: -120px;
            transition: all 0.3s;
            z-index: 999;
        }
        .mob-burger-container.open {
            border-radius: 0;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            transition: all 0.3s;
            background-color: #041d45;
        }
        .mob-burger-icon {
            position: absolute;
            top: 120px;
            left: 130px;
            z-index: 1500;
            transition: all 0.3s;
            color: white;
            font-size: 2em;
            pointer-events: all;
        }
        .mob-burger-container.open .mob-burger-icon {
            top: 20px;
            left: 20px;
            z-index: 1500;
        }
        .mob-close-btn {
            position: absolute;
            top: 20px;
            left: 20px;
            z-index: 1600;
            cursor: pointer;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        @keyframes fadeInRight {
          0% { opacity: 0; left: 20%; }
          100% { opacity: 1; left: 0; }
        }
        @keyframes rotateX {
          0% { opacity: 0; transform: rotateX(-90deg); }
          50% { transform: rotateX(-20deg); }
          100% { opacity: 1; transform: rotateX(0deg); }
        }
        .mob-overlay {
          position: fixed; top: 0; left: 0;
          width: 100%; height: 0%; opacity: 0;
          visibility: hidden; overflow: hidden;
          background: #transparent; z-index: 1450;
          display: flex; align-items: center; justify-content: center;
          transition: opacity 0.3s, height 0s 0.3s;
        }
        .mob-overlay.open {
          opacity: 1; visibility: visible; height: 100%;
          transition: opacity 0.4s 0.2s, height 0s 0s;
        }
        .mob-nav { text-align: center; }
        .mob-nav > ul { list-style: none; padding: 0; margin: 0; align-items: center;}
        .mob-nav > ul > li {
          opacity: 0; position: relative;
          animation: fadeInRight 0.5s ease forwards;
        }
        .mob-nav > ul > li:nth-of-type(1) { animation-delay: 0.35s; }
        .mob-nav > ul > li:nth-of-type(2) { animation-delay: 0.45s; }
        .mob-nav > ul > li:nth-of-type(3) { animation-delay: 0.55s; }
        .mob-nav > ul > li:nth-of-type(4) { animation-delay: 0.65s; }
        .mob-nav > ul > li:nth-of-type(5) { animation-delay: 0.75s; }
        .mob-nav button, .mob-nav > ul > li > button {
          font-family: 'Poppins', sans-serif;
          font-size: 1em; font-weight: 700;
          color: #fff; text-decoration: none;
          background: none; border: none; cursor: pointer;
          padding: 2px 0; 
          opacity: 0.8;
          transition: opacity 0.2s, transform 0.2s;
          display: flex; align-items: center; gap: 8px;
          justify-content: center;
          width: 100%;
        }
        .mob-nav button:hover, .mob-nav > ul > li > button:hover {
          opacity: 1; transform: scale(1.08);
        }
        .mob-submenu {
          list-style: none; padding: 0; margin: 4px 0 8px;
          perspective: 1000px;
          text-align: center;
          width: 100%;
        }
        .mob-submenu li {
          opacity: 0; transform-origin: top center;
          animation: rotateX 300ms ease-in-out forwards;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 100%;
        }
        .mob-submenu li:nth-of-type(1) { animation-delay: 60ms; }
        .mob-submenu li:nth-of-type(2) { animation-delay: 120ms; }
        .mob-submenu li:nth-of-type(3) { animation-delay: 180ms; }
        .mob-submenu li:nth-of-type(4) { animation-delay: 240ms; }
        .mob-submenu li button {
          font-family: 'Poppins', sans-serif;
          font-size: 1.2em !important; color: rgba(255,255,255,0.9);
          font-weight: 500 !important; background: none;
          border: none; cursor: pointer; padding: 0;
          justify-content: center;
          width: 100%;
          display: flex;
          align-items: center;
        }
        .mob-chevron { font-size: 0.4em; opacity: 0.7; margin-left: 6px; }
        .mob-divider {
          border-top: 1px solid rgba(255,255,255,0.3);
          margin: 12px 0; padding-top: 12px;
        }
      `}
      />

      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <div
          className={`mob-burger-container ${open ? "open" : ""}`}
          onClick={() => !open && setOpen(true)}
        >
          {!open && (
            <div className="mob-burger-icon">
              <MenuIcon fontSize="large" />
            </div>
          )}
        </div>
      </Box>
      <div className={`mob-overlay ${open ? "open" : ""}`}>
        <div className="mob-close-btn" onClick={() => setOpen(false)}>
          <CloseIcon fontSize="large" />
        </div>
        <nav className="mob-nav">
          <ul>
            {navRoutes.map((route: any, i: number) => (
              <li key={route.key} style={{ animationDelay: `${0.35 + i * 0.1}s` }}>
                {route.collapse ? (
                  <>
                    <button onClick={() => toggleSubmenu(route.key)}>
                      {route.name}
                      <span className="mob-chevron">{openSubmenus[route.key] ? "▲" : "▼"}</span>
                    </button>
                    {openSubmenus[route.key] && (
                      <ul className="mob-submenu" style={{ width: "100%" }}>
                        {renderItems(route.collapse, 1)}
                      </ul>
                    )}
                  </>
                ) : (
                  <button
                    onClick={() => {
                      navigate(route.route);
                      setOpen(false);
                    }}
                  >
                    {route.name}
                  </button>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </>
  );
}
